"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Skeleton"));
var Skeleton_1 = require("./Skeleton");
exports.default = Skeleton_1.default;
//# sourceMappingURL=index.js.map